import { post, get } from "@utils/axios";

export const login = (payload) => {
    return post("login", payload, false);
}

export const forget = (payload) => {
    return post("forgot-password", payload, false);
}

export const reset = (payload) => {
    return post("reset-password", payload, false);
}

/**
 * Revoke this session's token server-side. Signing out used to clear the
 * browser only, leaving the token usable by anyone who had a copy of it
 * until it expired on its own.
 */
export const logoutReq = () => {
    return get("logout");
}

export const register = (payload) => {
    return post("register", payload, false);
}
